package antd.input

import kotlinext.js.jsObject
import react.ComponentType
import react.RBuilder
import react.RHandler

fun RBuilder.input(handler: RHandler<InputProps>) = child(InputComponent::class, handler)
fun RBuilder.inputGroup(handler: RHandler<InputGroupProps>) = child(InputComponent.Group as ComponentType<InputGroupProps>, jsObject {  }, handler)
fun RBuilder.search(handler: RHandler<SearchProps>) = child(InputComponent.Search as ComponentType<SearchProps>, jsObject {  }, handler)
fun RBuilder.textArea(handler: RHandler<TextAreaProps>) = child(InputComponent.TextArea as ComponentType<TextAreaProps>, jsObject{},handler)
fun RBuilder.password(handler: RHandler<PasswordProps>) = child(InputComponent.Password as ComponentType<PasswordProps>, jsObject {  }, handler)
